export default __webpack_public_path__ + "static/media/tempo-CTA-background-2.df6cf251.png";